<p-card styleClass="flex w-full h-full p-4" class="h-full">
  <ng-template pTemplate="header">
    <h2>Overdue Reg. Fees (Recruited By Me)</h2>
  </ng-template>

  <div class="nano-content">
    <div *ngIf="paymentSummary.totalDue > 0" class="m-l m-r m-t m-b">
      <div>
        <span style="font-size: 18px; font-weight: 100; line-height: 1.1;" class="no-margins">Reg. Fees Paid</span>
        &nbsp;
        <span class="stat-percent pull-right" style="line-height:1.1; font-size:18px; font-weight:100;">{{percentage | number:'1.0-1'}}%</span>
        <br>
        <span class="small"><span style="font-weight: 600;">Goal:</span> 100%</span>
        <span class="stat-percent pull-right small" style="line-height:1.1;">({{formatCurrency(paymentSummary.totalPaid)}}/{{formatCurrency(paymentSummary.totalDue)}})</span>
      </div>

      <div class="progress progress-mini">
        <p-progressBar [value]="percentage" [showValue]="false" [style]="{'height': '10px'}"></p-progressBar>
      </div>
    </div>

    <div *ngIf="overdueFees().length === 0" class="text-center m-l m-r m-t">
      <div *ngIf="paymentSummary.totalDue > 0"><hr></div>
      <p>All your registration fees are paid... nice!</p>
    </div>

    <div *ngIf="overdueFees().length > 0">
      <p-table 
        [value]="overdueFees()" 
        [scrollable]="true" 
        styleClass="p-datatable-sm flex flex-col w-full"
        [rows]="5"
        [paginator]="true">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns()">
              <app-table-header [column]="col"></app-table-header>
            </th>
            <th class="text-right">Remaining</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-fee>
          <tr>
            <td *ngFor="let col of columns()">
              <app-table-column [column]="col" [data]="fee"></app-table-column>
            </td>
            <td class="text-right">{{formatCurrency(getRemainingAmount(fee))}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card> 